<template>
  <div class="col-12 col-md order-1 order-md-3 product-gallery" style="height: fit-content !important;">
    <div class="border p-3 p-lg-4 h-100">
      <div class="product-gallery-main-img border border-primary">
        <img class="img-fluid" src="" alt="" />
        <a class="product-favorite" @click.stop="toggleIsInWishList" style="color: #000 !important;">
          <ClientOnly>
            <i class="fa-solid fa-heart fs-1" v-if="$store.getters['user/isProductInWishlist'](product.sku)" style="color:#d2101d;"></i>
            <i class="fa-regular fa-heart fs-1" v-else></i>
          </ClientOnly>
        </a>
        <a class="product-img-lighbox btn" href="#" role="button" data-toggle="modal" data-target="#lightbox-modal">
          <span class="fa-stack">
            <ClientOnly><i class="fas fa-search-plus"></i></ClientOnly>
          </span>
        </a>
      </div>
      <div class="product-img-thumb mt-4 mx-auto px-5">
        <div class="product-img-thumb-wrapper">
          <div class="product-img-thumb-wrapper-inner">
            <div class="product-img-thumb-slide" v-for="(image, i) of images" :key="i">
              <img :src="image.url" :data-big-src="image.url" width="80" height="120" />
            </div>
          </div>
        </div>
        <div class="product-img-thumb-prev swiper-button-prev"></div>
        <div class="product-img-thumb-next swiper-button-next"></div>
      </div>
      <div class="modal fade" id="lightbox-modal" tabindex="-1" aria-labelledby="lightbox-modal-label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="lightbox-modal-label">{{ product.name }}</h1>
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div id="lightbox-carousel" class="carousel slide">
                <button class="carousel-control-prev" type="button" data-target="#lightbox-carousel" data-slide="prev">
                  <ClientOnly><i class="fa-solid fa-chevron-left fa-3x text-black" aria-hidden="true"></i></ClientOnly>
                  <span class="visually-hidden">Previous</span>
                </button>
                <div class="carousel-inner">
                  <div :class="{'carousel-item': true, 'active': i === 0}" v-for="(image, i) of images" :key="i">
                    <img class="d-block w-100" :src="image.url" alt="Complete Set Lederhose Jupp" />
                  </div>
                </div>
                <button class="carousel-control-next" type="button" data-target="#lightbox-carousel" data-slide="next">
                  <ClientOnly><i class="fa-solid fa-chevron-right fa-3x text-black" aria-hidden="true"></i></ClientOnly>
                  <span class="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*import { isServer } from "@storefront/core/helpers";*/
/*import ClientOnly from "vue-client-only";*/
import { mapGetters } from "vuex";
import ProductGallerySlider from '@/esf_antarctica_lederhosenland/assets/js/common.js';
import { Logger } from "@storefront/core/lib/logger";
import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
SwiperCore.use([Navigation]);
import ClientOnly from "vue-client-only";

export default {
  name: "ProductGallery",
  props: ["images", "isInWishList"],
  components: {
    ClientOnly
    /*ClientOnly,*/
    /*Carousel: () =>
      !isServer ? import("vue-carousel").then((m) => m.Carousel) : null,*/
    /*Slide: () =>
      !isServer ? import("vue-carousel").then((m) => m.Slide) : null,*/
    /*Lightbox: () => (!isServer ? import("vue-easy-lightbox") : null),*/
  },
  data() {
    return {
      selectedImage: this.images[0].url,
      noOfSlidePerPage: 1,
      imgs: "",
      visible: false,
      index: 0,
      slideNumber: 0,
    };
  },
  computed: {
    ...mapGetters({
      product: "product/getCurrentProduct",
    }),
    onSale() {
      return this.product.sale;
    },
    onNew() {
      return this.product.new;
    },
  },
  watch: {
    images: function (oldVal, newVal) {
      Logger.debug("newval[0]", "watch", newVal[0].url)();
      Logger.debug("this.selectedImage", "watch", this.selectedImage)();

      this.selectedImage = newVal[0].url;

      Logger.debug("this.selectedImage", "watch", this.selectedImage)();

      Logger.debug("oldVal", "watch", oldVal[0].url)();
      Logger.debug("newVal", "watch", newVal[0].url)();
      this.selectedImage = oldVal[0].url;
    },
    $route() {
      new ProductGallerySlider();
    }
  },
  mounted() {
    new ProductGallerySlider();
    /*this.init_slider();*/
    window.addEventListener("resize", this.setNoOfSlidePerPage);
    window.addEventListener("load", this.setNoOfSlidePerPage);
    this.setNoOfSlidePerPage();
  },
  destroyed() {
    Logger.debug("destroyed", "ProductGallery", "destroyed is called")();
    window.removeEventListener("resize", this.setNoOfSlidePerPage);
    window.removeEventListener("load", this.setNoOfSlidePerPage);
  },
  methods: {
    clickSlideGallery(e) {
      this.changeSelectedImage(e);
      // if (window.innerWidth < 768) {
      //   this.showMultiple();
      // }
    },
    changeSelectedImage(e) {
      const slideNumber = e.target.parentElement.id.replace(/^\D+/g, "");
      this.slideNumber = +slideNumber;
      this.selectedImage = this.images[slideNumber].url;
    },
    showMultiple() {
      this.imgs = this.images.map(image=>image.url);
      this.index = this.slideNumber;
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    setNoOfSlidePerPage() {
      this.noOfSlidePerPage = window.innerWidth < 768 ? 2 : 3;
    },
    toggleIsInWishList() {
      this.$emit("changeIsInWishList");
    },
    init_slider() {
      let product_thumb_swiper = new Swiper(".product-img-thumb .swiper", {
        breakpoints: {
          300: {
            slidesPerView: 2
          },
          350: {
            slidesPerView: 3
          },
          400: {
            slidesPerView: 4
          },
          576: {
            slidesPerView: 5
          },
          768: {
            slidesPerView: 4
          },
          992: {
            slidesPerView: 5
          },
          1200: {
            slidesPerView: 6
          }
        },
        spaceBetween: 10,
        speed: 300,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        clickable: true,
        centeredSlides: true,
        autoHeight: true,
        navigation: {
          nextEl: ".product-img-thumb-swiper-button-next",
          prevEl: ".product-img-thumb-swiper-button-prev",
        },
        on: {
          click: function(swiper) {
            swiper.slideTo(swiper.slides.indexOf(swiper.clickedSlide));
          }
        },
      }),
      product_main_img_swiper = new Swiper(".product-gallery-main-img .swiper", {
        spaceBetween: 10,
        slidesPerView: 1,
        speed: 0,
        navigation: {
          nextEl: ".product-main-img-swiper-button-next",
          prevEl: ".product-main-img-swiper-button-prev",
        },
        thumbs: {
          swiper: product_thumb_swiper,
        },
      }),
      offers_add_swiper_options = {
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 60
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 80
          }
        },
        speed: 400,
        navigation: {
          nextEl: '.offers-swiper-button-next',
          prevEl: '.offers-swiper-button-prev',
        },
      },
      offers_add_swiper = false;
      product_thumb_swiper.on('slideChange', () => {
        product_main_img_swiper.slideTo(product_thumb_swiper.activeIndex);
      });
      if(window.innerWidth >= 992) {
        if( !offers_add_swiper ) {
          if(document.querySelector('.offers .product-grid') && document.querySelector('.offers .product-grid').classList){
            document.querySelector('.offers .product-grid').classList.add('product-grid-carousel')
          }
          if(document.querySelector('.offers .swiper > .row') && document.querySelector('.offers .swiper > .row').classList){
            document.querySelector('.offers .swiper > .row').classList.add('swiper-wrapper')
          }
          document.querySelectorAll('.offers .swiper > .row > div').forEach(function (ele) {
            if(ele && ele.classList){
              ele.classList.add('swiper-slide')
            }
          })
          offers_add_swiper = new Swiper('.offers .swiper', offers_add_swiper_options)
        }
      } else if(offers_add_swiper.initialized) {
        offers_add_swiper.destroy()
        offers_add_swiper = false
        if(document.querySelector('.offers .product-grid') && document.querySelector('.offers .product-grid').classList){
          document.querySelector('.offers .product-grid').classList.remove('product-grid-carousel')
        }
        if(document.querySelector('.offers .swiper > .row') && document.querySelector('.offers .swiper > .row').classList){
          document.querySelector('.offers .swiper > .row').classList.remove('swiper-wrapper')
        }
        document.querySelectorAll('.offers .swiper > .row > div').forEach(function (ele) {
          if(ele && ele.classList){
            ele.classList.remove('swiper-slide')
          }
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
